/**
 * @descriptor 企微扫码
 * @author obf1313
 */
import { useEffect } from 'react'
import { useSelector, shallowEqual } from 'dva'
import workWechatConfig from 'utils/work-wechat-config'
import qs from 'query-string'
import { loginRedirectUrl } from 'utils'
import './index.less'

const selector = ({ session }) => ({
  userInfo: session.userInfo,
})

const WechatLogin = () => {
  const { userInfo } = useSelector(selector, shallowEqual)

  useEffect(() => {
    let search =
      window.sessionStorage.getItem('search') || `?url=${loginRedirectUrl()}`

    let searchObj = qs.parse(search)
    !searchObj?.applicationCode &&
      (search += `&applicationCode=${searchObj?.applicationCode || 'passport'}`)

    const state = encodeURIComponent(
      encodeURIComponent(
        JSON.stringify({ type: 'code_console', workId: userInfo?.workId })
      )
    )

    // @ts-ignore
    window.WwLogin({
      id: 'wechat-qrcode',
      appid: workWechatConfig.appid,
      agentid: workWechatConfig.agentid,
      redirect_uri: encodeURIComponent(workWechatConfig.redirect_uri + search),
      state: state,
      /**
       * 使用base64编码注入以下样式
        .impowerBox .qrcode {width: 180px;}
        .impowerBox  .wrp_code {margin-top:0 !important;}
        .impowerBox .title {display: none;}
        .status_icon {display: none}
        .impowerBox .status {text-align: center;}
      */
      href: 'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE4MHB4O30NCi5pbXBvd2VyQm94ICAud3JwX2NvZGUge21hcmdpbi10b3A6MCAhaW1wb3J0YW50O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9DQouaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQ==',
    })
  }, [userInfo])

  return <div id="wechat-qrcode"></div>
}
export default WechatLogin
